// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Set Top Box Demo - Clean Professional Design */

/* Base Variables */
:root {
  --stb-primary: #4D64C1;
  --stb-primary-dark: #3a4f9e;
  --stb-primary-light: #6b7fd1;
  --stb-primary-ultralight: #f0f3ff;
  
  --stb-text-primary: #1a1a1a;
  --stb-text-secondary: #6c757d;
  --stb-text-light: #8a94a6;
  
  --stb-bg-white: #ffffff;
  --stb-bg-light: #f8f9fa;
  --stb-bg-lighter: #fafbfc;
  
  --stb-border: #e5e7eb;
  --stb-border-light: #f1f3f5;
  
  --stb-success: #22c55e;
  --stb-success-light: #e7f7ed;
  
  --stb-shadow-sm: 0 1px 3px rgba(0,0,0,0.06);
  --stb-shadow-md: 0 4px 6px rgba(0,0,0,0.08);
  --stb-shadow-lg: 0 10px 15px rgba(0,0,0,0.1);
  
  --stb-radius: 8px;
  --stb-radius-lg: 12px;
  
  --stb-transition: all 0.2s ease;
}

/* Hero Section */
.stb-demo-hero {
  background: linear-gradient(135deg, var(--stb-primary) 0%, var(--stb-primary-dark) 100%);
  color: white;
  padding: 2.5rem 0 2rem;
  margin-bottom: 0;
  position: relative;
  overflow: hidden;
}

.stb-demo-hero::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -10%;
  width: 50%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);
  transform: rotate(-15deg);
}

/* Demo Mode Badge */
.demo-mode-badge {
  position: fixed;
  top: 80px;
  right: 20px;
  background: #ffd54f;
  color: #1a1a1a;
  padding: 10px 24px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  z-index: 1000;
  border: 2px solid #ffb300;
}

.demo-mode-badge i {
  font-size: 16px;
}

/* Hero Content */
.hero-content {
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.stb-demo-hero h1 {
  font-size: 2.75rem;
  font-weight: 700;
  margin-bottom: 1rem;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.stb-demo-hero .lead {
  font-size: 1.25rem;
  opacity: 0.95;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.7;
  font-weight: 300;
}


/* Main Content */
.stb-demo-content {
  background: var(--stb-bg-light);
  padding: 3rem 0;
  min-height: calc(100vh - 400px);
}

/* Section Titles */
.section-title {
  font-size: 2rem;
  font-weight: 600;
  color: var(--stb-text-primary);
  margin-bottom: 0.75rem;
  position: relative;
  display: inline-block;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 60px;
  height: 4px;
  background: var(--stb-primary);
  border-radius: 2px;
}

.section-subtitle {
  font-size: 1.125rem;
  color: var(--stb-text-secondary);
  margin-bottom: 3rem;
  margin-top: 1.5rem;
}

/* STB Model Selection */
.stb-model-selection {
  margin-bottom: 5rem;
  text-align: center;
}

.stb-models-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
  align-items: stretch;
}

/* Fade in animation for cards */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stb-model-card {
  animation: fadeInUp 0.5s ease-out backwards;
  background: var(--stb-bg-white);
  border: 2px solid #e0e0e0;
  border-radius: 16px;
  padding: 2rem 1.5rem 1.75rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stb-model-card:hover {
  border-color: var(--stb-primary);
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
  transform: translateY(-4px);
}

.stb-model-card.selected {
  border-color: var(--stb-primary);
  background: linear-gradient(135deg, #f5f7ff 0%, #e8ecff 100%);
  box-shadow: 0 0 0 4px rgba(77,100,193,0.15), 0 4px 12px rgba(77,100,193,0.1);
  transform: scale(1.02);
}

/* Model Image */
.stb-model-image {
  width: 160px;
  height: 160px;
  margin: 0 auto 1rem;
  position: relative;
  background: var(--stb-bg-lighter);
  border-radius: var(--stb-radius);
  padding: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.model-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Model Info */
.stb-model-info {
  text-align: center;
}

.stb-model-info h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--stb-text-primary);
  margin: 0;
  line-height: 1.4;
}

.model-name {
  font-size: 0.875rem;
  color: var(--stb-text-secondary);
  margin: 0 0 0.25rem 0;
  font-weight: 500;
}

.model-sku {
  font-size: 0.75rem;
  color: var(--stb-text-light);
  margin: 0;
}

.model-price {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--stb-primary);
  margin-top: auto;
  margin-bottom: 1.25rem;
  font-variant-numeric: tabular-nums;
}

/* Model Features */
.model-features {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: auto;
}

.model-features .badge {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
  border-radius: 999px;
  font-weight: 500;
}

.model-features .bg-primary {
  background-color: var(--stb-primary) !important;
  color: white;
}

.model-features .bg-success {
  background-color: var(--stb-success) !important;
  color: white;
}

/* Visual indicator for selected card */
.stb-model-card.selected::after {
  content: '✓';
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 24px;
  height: 24px;
  background: var(--stb-primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

/* Animation delays for sequential fade-in */
.stb-model-card:nth-child(1) { animation-delay: 0.1s; }
.stb-model-card:nth-child(2) { animation-delay: 0.2s; }
.stb-model-card:nth-child(3) { animation-delay: 0.3s; }
.stb-model-card:nth-child(4) { animation-delay: 0.4s; }
.stb-model-card:nth-child(5) { animation-delay: 0.5s; }

/* Category Section */
.accessories-section {
  margin-bottom: 3rem;
  text-align: center;
}

.section-header {
  margin-bottom: 3rem;
}

.section-header > div:first-child {
  margin-bottom: 1.5rem;
}

/* Category Pills */
.category-pills {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.category-pill {
  padding: 0.625rem 1.25rem;
  border: 1px solid var(--stb-border);
  background: var(--stb-bg-white);
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--stb-transition);
  color: var(--stb-text-secondary);
}

.category-pill:hover {
  border-color: var(--stb-primary);
  color: var(--stb-primary);
}

.category-pill.active {
  background: var(--stb-primary);
  border-color: var(--stb-primary);
  color: white;
}

/* Accessories Grid */
.accessories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.accessory-card {
  background: var(--stb-bg-white);
  border: 1px solid var(--stb-border-light);
  border-radius: var(--stb-radius-lg);
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.accessory-card:hover {
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  transform: translateY(-4px);
  border-color: var(--stb-primary-light);
}

/* Accessory Image */
.accessory-image {
  width: 100%;
  height: 180px;
  background: var(--stb-bg-lighter);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.accessory-image .product-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 1rem;
}

/* Accessory Details */
.accessory-details {
  padding: 1.5rem;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.accessory-details h4 {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--stb-text-primary);
  margin-bottom: 0.375rem;
  line-height: 1.4;
}

.accessory-details .sku {
  font-size: 0.875rem;
  color: var(--stb-text-light);
  margin-bottom: 0.75rem;
}

.accessory-details .description {
  font-size: 0.875rem;
  color: var(--stb-text-secondary);
  line-height: 1.5;
  margin-bottom: 1rem;
  flex: 1 1;
}

/* Accessory Meta */
.accessory-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.category-tag {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
  background: var(--stb-bg-light);
  border-radius: 999px;
  color: var(--stb-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stock-status {
  font-size: 0.875rem;
  color: var(--stb-success);
  font-weight: 500;
}

/* Accessory Footer */
.accessory-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 1px solid var(--stb-border-light);
}

.price-info {
  display: flex;
  flex-direction: column;
}

.price-info .price {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--stb-text-primary);
}

.price-info .min-qty {
  font-size: 0.875rem;
  color: var(--stb-text-secondary);
}

/* Add to Cart Button */
.add-to-cart-btn {
  background: var(--stb-primary);
  color: white;
  border: none;
  padding: 0.625rem 1.25rem;
  border-radius: var(--stb-radius);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--stb-transition);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.add-to-cart-btn:hover:not(:disabled) {
  background: var(--stb-primary-dark);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(77,100,193,0.3);
}

.add-to-cart-btn:disabled {
  background: var(--stb-text-light);
  cursor: not-allowed;
}

/* Loading & Empty States */
.spinner-border {
  color: var(--stb-primary);
}

.alert {
  border-radius: var(--stb-radius);
  padding: 1rem 1.5rem;
  margin: 2rem 0;
  border: none;
}

.alert-info {
  background: #e0f2fe;
  color: #0369a1;
}

.alert-danger {
  background: #fee2e2;
  color: #dc2626;
}

/* Smart Image Fallback */
.smart-image-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--stb-bg-lighter);
  color: var(--stb-text-light);
}

.smart-image-fallback img {
  width: 60%;
  height: 60%;
  object-fit: contain;
  opacity: 0.7;
}

/* Empty State Message */
.alert {
  max-width: 600px;
  margin: 3rem auto;
  text-align: center;
}

/* Responsive Design */
@media (max-width: 768px) {
  .demo-mode-badge {
    top: 10px;
    right: 10px;
    font-size: 12px;
    padding: 6px 16px;
  }
  
  .demo-mode-badge i {
    font-size: 14px;
  }
  .stb-demo-hero {
    padding: 2rem 0;
  }
  
  .stb-demo-hero h1 {
    font-size: 2rem;
  }
  
  .stb-demo-hero .lead {
    font-size: 1rem;
  }
  
  .demo-options .btn-group {
    flex-direction: column;
    width: 100%;
    max-width: 280px;
    margin: 0 auto;
  }
  
  .demo-options .btn {
    width: 100%;
  }
  
  .section-title {
    font-size: 1.5rem;
  }
  
  .stb-models-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
  }
  
  .stb-model-card {
    padding: 1rem;
  }
  
  .stb-model-image {
    width: 120px;
    height: 120px;
  }
  
  .section-header {
    flex-direction: column;
    align-items: stretch;
  }
  
  .category-pills {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    flex-wrap: nowrap;
    padding-bottom: 0.5rem;
  }
  
  .category-pill {
    flex-shrink: 0;
  }
  
  .accessories-grid {
    grid-template-columns: 1fr;
  }
  
  .accessory-footer {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  .add-to-cart-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .stb-models-grid {
    grid-template-columns: 1fr;
  }
}

/* Remove any conflicting styles from main-content */
.main-content {
  padding: 0 !important;
  background: transparent !important;
}

/* Ensure no gaps between sections */
.stb-demo-content > .container:first-child {
  padding-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/SetTopBoxDemo.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD,mBAAmB;AACnB;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;;EAEjC,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;;EAEzB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;;EAEzB,qBAAqB;EACrB,2BAA2B;;EAE3B,sBAAsB;EACtB,4BAA4B;;EAE5B,2CAA2C;EAC3C,2CAA2C;EAC3C,4CAA4C;;EAE5C,iBAAiB;EACjB,qBAAqB;;EAErB,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,wFAAwF;EACxF,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,YAAY;EACZ,+EAA+E;EAC/E,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,eAAe;EACf,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,6DAA6D;EAC7D,4EAA4E;EAC5E,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;AACtD,+BAA+B,qBAAqB,EAAE;;AAEtD,qBAAqB;AACrB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,SAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,oBAAoB;EACpB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,oDAAoD;AACpD;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB","sourcesContent":["/* Set Top Box Demo - Clean Professional Design */\n\n/* Base Variables */\n:root {\n  --stb-primary: #4D64C1;\n  --stb-primary-dark: #3a4f9e;\n  --stb-primary-light: #6b7fd1;\n  --stb-primary-ultralight: #f0f3ff;\n  \n  --stb-text-primary: #1a1a1a;\n  --stb-text-secondary: #6c757d;\n  --stb-text-light: #8a94a6;\n  \n  --stb-bg-white: #ffffff;\n  --stb-bg-light: #f8f9fa;\n  --stb-bg-lighter: #fafbfc;\n  \n  --stb-border: #e5e7eb;\n  --stb-border-light: #f1f3f5;\n  \n  --stb-success: #22c55e;\n  --stb-success-light: #e7f7ed;\n  \n  --stb-shadow-sm: 0 1px 3px rgba(0,0,0,0.06);\n  --stb-shadow-md: 0 4px 6px rgba(0,0,0,0.08);\n  --stb-shadow-lg: 0 10px 15px rgba(0,0,0,0.1);\n  \n  --stb-radius: 8px;\n  --stb-radius-lg: 12px;\n  \n  --stb-transition: all 0.2s ease;\n}\n\n/* Hero Section */\n.stb-demo-hero {\n  background: linear-gradient(135deg, var(--stb-primary) 0%, var(--stb-primary-dark) 100%);\n  color: white;\n  padding: 2.5rem 0 2rem;\n  margin-bottom: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.stb-demo-hero::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -10%;\n  width: 50%;\n  height: 200%;\n  background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);\n  transform: rotate(-15deg);\n}\n\n/* Demo Mode Badge */\n.demo-mode-badge {\n  position: fixed;\n  top: 80px;\n  right: 20px;\n  background: #ffd54f;\n  color: #1a1a1a;\n  padding: 10px 24px;\n  border-radius: 999px;\n  font-size: 16px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.3);\n  z-index: 1000;\n  border: 2px solid #ffb300;\n}\n\n.demo-mode-badge i {\n  font-size: 16px;\n}\n\n/* Hero Content */\n.hero-content {\n  text-align: center;\n  max-width: 900px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.stb-demo-hero h1 {\n  font-size: 2.75rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  letter-spacing: -0.5px;\n  text-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.stb-demo-hero .lead {\n  font-size: 1.25rem;\n  opacity: 0.95;\n  max-width: 700px;\n  margin: 0 auto;\n  line-height: 1.7;\n  font-weight: 300;\n}\n\n\n/* Main Content */\n.stb-demo-content {\n  background: var(--stb-bg-light);\n  padding: 3rem 0;\n  min-height: calc(100vh - 400px);\n}\n\n/* Section Titles */\n.section-title {\n  font-size: 2rem;\n  font-weight: 600;\n  color: var(--stb-text-primary);\n  margin-bottom: 0.75rem;\n  position: relative;\n  display: inline-block;\n}\n\n.section-title::after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 0;\n  width: 60px;\n  height: 4px;\n  background: var(--stb-primary);\n  border-radius: 2px;\n}\n\n.section-subtitle {\n  font-size: 1.125rem;\n  color: var(--stb-text-secondary);\n  margin-bottom: 3rem;\n  margin-top: 1.5rem;\n}\n\n/* STB Model Selection */\n.stb-model-selection {\n  margin-bottom: 5rem;\n  text-align: center;\n}\n\n.stb-models-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n  margin-top: 2rem;\n  align-items: stretch;\n}\n\n/* Fade in animation for cards */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.stb-model-card {\n  animation: fadeInUp 0.5s ease-out backwards;\n  background: var(--stb-bg-white);\n  border: 2px solid #e0e0e0;\n  border-radius: 16px;\n  padding: 2rem 1.5rem 1.75rem;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  text-align: center;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.04);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.stb-model-card:hover {\n  border-color: var(--stb-primary);\n  box-shadow: 0 8px 24px rgba(0,0,0,0.08);\n  transform: translateY(-4px);\n}\n\n.stb-model-card.selected {\n  border-color: var(--stb-primary);\n  background: linear-gradient(135deg, #f5f7ff 0%, #e8ecff 100%);\n  box-shadow: 0 0 0 4px rgba(77,100,193,0.15), 0 4px 12px rgba(77,100,193,0.1);\n  transform: scale(1.02);\n}\n\n/* Model Image */\n.stb-model-image {\n  width: 160px;\n  height: 160px;\n  margin: 0 auto 1rem;\n  position: relative;\n  background: var(--stb-bg-lighter);\n  border-radius: var(--stb-radius);\n  padding: 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.model-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n/* Model Info */\n.stb-model-info {\n  text-align: center;\n}\n\n.stb-model-info h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--stb-text-primary);\n  margin: 0;\n  line-height: 1.4;\n}\n\n.model-name {\n  font-size: 0.875rem;\n  color: var(--stb-text-secondary);\n  margin: 0 0 0.25rem 0;\n  font-weight: 500;\n}\n\n.model-sku {\n  font-size: 0.75rem;\n  color: var(--stb-text-light);\n  margin: 0;\n}\n\n.model-price {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--stb-primary);\n  margin-top: auto;\n  margin-bottom: 1.25rem;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Model Features */\n.model-features {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: auto;\n}\n\n.model-features .badge {\n  font-size: 0.75rem;\n  padding: 0.375rem 0.75rem;\n  border-radius: 999px;\n  font-weight: 500;\n}\n\n.model-features .bg-primary {\n  background-color: var(--stb-primary) !important;\n  color: white;\n}\n\n.model-features .bg-success {\n  background-color: var(--stb-success) !important;\n  color: white;\n}\n\n/* Visual indicator for selected card */\n.stb-model-card.selected::after {\n  content: '✓';\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 24px;\n  height: 24px;\n  background: var(--stb-primary);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n/* Animation delays for sequential fade-in */\n.stb-model-card:nth-child(1) { animation-delay: 0.1s; }\n.stb-model-card:nth-child(2) { animation-delay: 0.2s; }\n.stb-model-card:nth-child(3) { animation-delay: 0.3s; }\n.stb-model-card:nth-child(4) { animation-delay: 0.4s; }\n.stb-model-card:nth-child(5) { animation-delay: 0.5s; }\n\n/* Category Section */\n.accessories-section {\n  margin-bottom: 3rem;\n  text-align: center;\n}\n\n.section-header {\n  margin-bottom: 3rem;\n}\n\n.section-header > div:first-child {\n  margin-bottom: 1.5rem;\n}\n\n/* Category Pills */\n.category-pills {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.category-pill {\n  padding: 0.625rem 1.25rem;\n  border: 1px solid var(--stb-border);\n  background: var(--stb-bg-white);\n  border-radius: 999px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--stb-transition);\n  color: var(--stb-text-secondary);\n}\n\n.category-pill:hover {\n  border-color: var(--stb-primary);\n  color: var(--stb-primary);\n}\n\n.category-pill.active {\n  background: var(--stb-primary);\n  border-color: var(--stb-primary);\n  color: white;\n}\n\n/* Accessories Grid */\n.accessories-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.accessory-card {\n  background: var(--stb-bg-white);\n  border: 1px solid var(--stb-border-light);\n  border-radius: var(--stb-radius-lg);\n  overflow: hidden;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.accessory-card:hover {\n  box-shadow: 0 8px 24px rgba(0,0,0,0.12);\n  transform: translateY(-4px);\n  border-color: var(--stb-primary-light);\n}\n\n/* Accessory Image */\n.accessory-image {\n  width: 100%;\n  height: 180px;\n  background: var(--stb-bg-lighter);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.accessory-image .product-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  padding: 1rem;\n}\n\n/* Accessory Details */\n.accessory-details {\n  padding: 1.5rem;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.accessory-details h4 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--stb-text-primary);\n  margin-bottom: 0.375rem;\n  line-height: 1.4;\n}\n\n.accessory-details .sku {\n  font-size: 0.875rem;\n  color: var(--stb-text-light);\n  margin-bottom: 0.75rem;\n}\n\n.accessory-details .description {\n  font-size: 0.875rem;\n  color: var(--stb-text-secondary);\n  line-height: 1.5;\n  margin-bottom: 1rem;\n  flex: 1;\n}\n\n/* Accessory Meta */\n.accessory-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.category-tag {\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.25rem 0.75rem;\n  background: var(--stb-bg-light);\n  border-radius: 999px;\n  color: var(--stb-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stock-status {\n  font-size: 0.875rem;\n  color: var(--stb-success);\n  font-weight: 500;\n}\n\n/* Accessory Footer */\n.accessory-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 1rem;\n  border-top: 1px solid var(--stb-border-light);\n}\n\n.price-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.price-info .price {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--stb-text-primary);\n}\n\n.price-info .min-qty {\n  font-size: 0.875rem;\n  color: var(--stb-text-secondary);\n}\n\n/* Add to Cart Button */\n.add-to-cart-btn {\n  background: var(--stb-primary);\n  color: white;\n  border: none;\n  padding: 0.625rem 1.25rem;\n  border-radius: var(--stb-radius);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--stb-transition);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.add-to-cart-btn:hover:not(:disabled) {\n  background: var(--stb-primary-dark);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(77,100,193,0.3);\n}\n\n.add-to-cart-btn:disabled {\n  background: var(--stb-text-light);\n  cursor: not-allowed;\n}\n\n/* Loading & Empty States */\n.spinner-border {\n  color: var(--stb-primary);\n}\n\n.alert {\n  border-radius: var(--stb-radius);\n  padding: 1rem 1.5rem;\n  margin: 2rem 0;\n  border: none;\n}\n\n.alert-info {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.alert-danger {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n/* Smart Image Fallback */\n.smart-image-fallback {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--stb-bg-lighter);\n  color: var(--stb-text-light);\n}\n\n.smart-image-fallback img {\n  width: 60%;\n  height: 60%;\n  object-fit: contain;\n  opacity: 0.7;\n}\n\n/* Empty State Message */\n.alert {\n  max-width: 600px;\n  margin: 3rem auto;\n  text-align: center;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .demo-mode-badge {\n    top: 10px;\n    right: 10px;\n    font-size: 12px;\n    padding: 6px 16px;\n  }\n  \n  .demo-mode-badge i {\n    font-size: 14px;\n  }\n  .stb-demo-hero {\n    padding: 2rem 0;\n  }\n  \n  .stb-demo-hero h1 {\n    font-size: 2rem;\n  }\n  \n  .stb-demo-hero .lead {\n    font-size: 1rem;\n  }\n  \n  .demo-options .btn-group {\n    flex-direction: column;\n    width: 100%;\n    max-width: 280px;\n    margin: 0 auto;\n  }\n  \n  .demo-options .btn {\n    width: 100%;\n  }\n  \n  .section-title {\n    font-size: 1.5rem;\n  }\n  \n  .stb-models-grid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 1rem;\n  }\n  \n  .stb-model-card {\n    padding: 1rem;\n  }\n  \n  .stb-model-image {\n    width: 120px;\n    height: 120px;\n  }\n  \n  .section-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .category-pills {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    flex-wrap: nowrap;\n    padding-bottom: 0.5rem;\n  }\n  \n  .category-pill {\n    flex-shrink: 0;\n  }\n  \n  .accessories-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .accessory-footer {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n  \n  .add-to-cart-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .stb-models-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Remove any conflicting styles from main-content */\n.main-content {\n  padding: 0 !important;\n  background: transparent !important;\n}\n\n/* Ensure no gaps between sections */\n.stb-demo-content > .container:first-child {\n  padding-top: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
